import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { editorStickerKeyURLs } from 'selectors/remoteResources';
import UpgradeIcon from 'components/shared/DesignSystem/UpgradeIcon';
import useLogoSticker from './useLogoSticker';

const StickerContainer = styled.a`
  position: relative;
  :hover img {
    transform: scale(1);
  }
`;

const StickerImage = styled.img`
  width: 100%;
  max-width: 150px;
  height: auto;
  transform: scale(0.6);
  opacity: ${(props) => (props.displayAsDisabled ? 0.5 : 1)};
`;

const NoImageUploadedText = styled.p`
  border: 1px dashed;
  border-radius: var(--cc_size_border_width_xl);
  color: var(--cc_color_text_subtle);
  padding: var(--cc_size_spacing_l);
`;

const StickerChoices = ({ onSelectSticker }) => {
  const stickerKeyURLs = useSelector(editorStickerKeyURLs);

  const logoInfo = useLogoSticker();

  const logoSticker = useMemo(() => {
    if (!logoInfo.ready) {
      return null;
    }
    return (
      <StickerContainer
        key="logo"
        href="javascript:void(0);"
        onClick={() => {
          // NOTE: Later, we may want to prompt for upgrade/logo upload
          if (logoInfo.canAccessLogoStickers && logoInfo.hasBeenUploaded) {
            onSelectSticker({ key: 'logo', src: logoInfo.src });
          }
        }}
      >
        {logoInfo.hasBeenUploaded ? (
          <StickerImage
            src={logoInfo.src}
            displayAsDisabled={!logoInfo.canAccessLogoStickers}
            crossOrigin="anonymous"
          />
        ) : (
          <NoImageUploadedText>No Logo Found</NoImageUploadedText>
        )}
        {logoInfo.canAccessLogoStickers ? null : (
          <UpgradeIcon
            size="large"
            style={{ position: 'absolute', top: 4, right: 4 }}
          />
        )}
      </StickerContainer>
    );
  }, [logoInfo, onSelectSticker]);

  const standardStickers = useMemo(
    () =>
      stickerKeyURLs.map((sticker) => (
        <StickerContainer
          key={sticker.key}
          href="javascript:void(0);"
          onClick={() =>
            onSelectSticker({ key: sticker.key, src: sticker.src })
          }
        >
          <StickerImage src={sticker.src} crossOrigin="anonymous" />
        </StickerContainer>
      )),
    [onSelectSticker, stickerKeyURLs],
  );

  return (
    <>
      {logoSticker}
      {standardStickers}
    </>
  );
};

StickerChoices.propTypes = {
  onSelectSticker: PropTypes.func.isRequired,
};

export default StickerChoices;
